import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { extractHashFromFilename } from '../../../core/booking-from.utils';

@Component({
  selector: 'app-file-status',
  imports: [CommonModule],
  standalone: true,

  template: `
    <div class="relative">
      <svg
        class="size-10"
        version="1.1"
        id="_x32_"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 512 512"
        xml:space="preserve"
        fill="#000000"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <style type="text/css">
            .st0 {
              fill: #000000;
            }
          </style>
          <g>
            <!-- Original surrounding shape remains intact -->
            <path
              class="st0"
              d="M378.413,0H208.297h-13.182L185.8,9.314L57.02,138.102l-9.314,9.314v13.176v265.514 c0,47.36,38.528,85.895,85.896,85.895h244.811c47.353,0,85.881-38.535,85.881-85.895V85.896C464.294,38.528,425.766,0,378.413,0z M432.497,426.105c0,29.877-24.214,54.091-54.084,54.091H133.602c-29.884,0-54.098-24.214-54.098-54.091V160.591h83.716 c24.885,0,45.077-20.178,45.077-45.07V31.804h170.116c29.87,0,54.084,24.214,54.084,54.092V426.105z"
            ></path>

            <!-- Bigger letter "B" -->
            <text
              x="50%"
              y="50%"
              font-size="200"
              text-anchor="middle"
              dy=".3em"
              class="st0"
            >
              {{ svgLetter }}
            </text>
          </g>
        </g>
      </svg>

      <!-- Check if pdfurl exists -->
      <ng-container *ngIf="hash && url; else noUrl">
        <!-- If pdfurl exists, check hash match -->
        <ng-container *ngIf="checkHashForUrl(hash, url); else hashMismatch">
          <!-- Green icon if hash matches -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            class="size-6 absolute -bottom-2 -right-[0.25rem] fill-white stroke-green-600/90"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>
        </ng-container>

        <!-- Yellow icon if hash doesn't match -->
        <ng-template #hashMismatch>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            class="size-6 absolute -bottom-2 -right-[0.25rem] fill-white stroke-yellow-400/90"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
            />
          </svg>
        </ng-template>
      </ng-container>

      <!-- Red icon if pdfurl does not exist -->
      <ng-template #noUrl>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          class="size-6 absolute -bottom-2 -right-[0.25rem] fill-white stroke-red-600/90"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
      </ng-template>
    </div>
  `,
  styles: ``,
})
export class FileStatusComponent {
  @Input({ required: true }) svgLetter!: string;
  @Input() hash?: string | undefined | null;
  @Input() url?: string | undefined | null;

  checkHashForUrl(hash: string, url: string): boolean {
    if (hash === extractHashFromFilename(url)) {
      return true;
    } else {
      return false;
    }
  }
}
